import AddIcon from "@mui/icons-material/Add";
import CustomButton from "./CustomButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const CreateModel = ({ onClick }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <CustomButton
      onClick={() => {
        navigate("/createresource");
      }}
      startIcon={<AddIcon />}
    >
      {t("dataModels.createdatamodelbutton")}
    </CustomButton>
  );
};

export default CreateModel;
